<div class="container-fluid h-100 readOnlyForm pl-0 pr-0">
	<!-- Section header start -->

	<div class="headerBackground card p-1 mb-2 tool-header-height">
		<div class="row padding2px">
			<div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 sectionHeaderIcon">
				<span>
          <fa-icon class="fas checklistIcon" title="click for smart checklist" (click)="openSmartChecklist()"  [icon]="faCircle">
          </fa-icon>
					<fa-icon class="fas fa-lg autoCursor" [icon]="faUser"></fa-icon>
				</span>
			</div>
			<div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-4">
				<h6 class="headerFontSize">{{ 'menu.personaMapper' | translate }}</h6>
			</div>
			<div class="col col-7 col-md-7 col-lg-7 col-sm-7 col-xs-6">
				<p class="titleParagraph">{{'personaMapper.toolHeaderLine1' | translate}}<br>
					{{'personaMapper.toolHeaderLine2' | translate}}
				</p>
			</div>
			<div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1">
				<table class="dropGroupBtn">
					<tr>
						<td class="iconGroupHeight">
							<span>
								<a id="personaYoutube" type="button" class="" data-toggle="modal" data-target="#ytVideoLinkPM">
									<fa-icon class="fas" [icon]="faInfoCircle" title="help"></fa-icon>
								</a>
							</span>
						</td>
						<td rowspan="2">
							<span
								(click)='loadMappersModel();mainComponent.setDetaultToggleValues("Persona", mainComponent.TFToggleStatus,mainComponent.URToggleStatus,mainComponent.BFToggleStatus,mainComponent.XXToggleStatus)'>
                <!-- personaMapperMindmap.controller.personaGraphShowHide(false);  -->
								<fa-icon class="fas fa-lg" [icon]="faProjectDiagram"
									(click)="mainComponent.openTool('personaMapperMindMap');mainComponent.createActivity('Pmg');interactionMapperComponent.setMappingSelectedXEutPersona('Persona','PM');interactionMapperComponent.setMappingSelectedyEutPersona('Requirement','');" routerLink="/main/personaMapperMindMap">
                  <!-- project.views.open('Pmm');interactionMapper.init(); -->
								</fa-icon>
							</span>
						</td>
					</tr>
					<tr class="bg-color-black">
						<td class="height25px">
							<span (click)="generateReport('true')">
								<fa-icon class="fas margintop7pxminus" [icon]="faFileExport" title="report"></fa-icon>
							</span>
						</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
	<!-- Section header end -->
	<div class="persona-mapper tool-body-height">
		<div class="card p-1 mb-2 bg-black h-100">
			<div class="persona-mapper-grid-table-height">
				<div class="row full-width only-bottom-padding h-50 card p-1 bg-white">
					<div class="table-responsive">
						<table class="table table-bordered border-none table-sm p-mapper tableBackgrdClrBlack menuItemsClrWhite">
							<tbody>
								<tr class="table-bordered-bottom"
									*ngFor="let p of model.personaMapUI[model.eutType]; let tabIndex = index">
									<th class="border-right1px border-left1px">
										{{p.name.pName}}
									</th>
									<td class="border-right1px mapperReadOnly persona-mappable-cell" *ngFor="let eut of p.eutList; let tabIndex = index"
										[ngClass]="{paleyellow:eut.map=='*'}" (click)="eut.map!=-1 && mapEUT(p,tabIndex,eut.eID)">
										<div style="text-align: center;">
											<b *ngIf="eut.map!=-1"></b>&nbsp;
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="table-nonresponsive p-mapper-table persona-ESD-pr-0">
						<table width="100%" border="0" cellspacing="0" cellpadding="0"
							class="table table-bordered border-none table-xs p-mapper tableBackgrdClrBlack">
							<tbody>
								<tr class="border-bottom1px"
									*ngFor="let p of model.personaMapIndex[model.eutType]; let tabIndex = index">
									<th class="border-left1px">
										&nbsp;
									</th>
									<td class="fontsize8pxESD border-right1px" *ngFor="let eut of p.eutList; let tabIndex = index"
										[ngClass]="{dis:eut.map==-1||eut.map!=''}" (click)="mapEUT(p,tabIndex,eut.eID)">
										<span *ngIf="eut.map!=-1">{{eut.map}}</span>&nbsp;
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="card p-1 bg-white h-50">
					<div class="row strict">
						<ul class="nav nav-tabs">
							<li class="active" id="yAxisRequirementTable">
								<a data-toggle="tab" ng-attr-data-target="#ur1" (click)="setEUTtypeChosen('UR')">
									{{ 'entities.Ur' | translate}}&nbsp;
									({{(modelData.listOfEUTs|landscaperEntity:{eType:'UR'}:filterTypeCount)}})
								</a>
							</li>
						</ul>
					</div>
					<div class="tab-content persona-requirement-table-height">
						<div ng-attr-id="ur1" class="tab-pane fade in active h-100">
							<ul class="alert-height list-group h-100 mb-0" *ngIf="!entityExists(model.eutType)" class="list-group">
								<div class="alert alert-warning mb-0">
									<strong>
										<div style="text-align: center;">
											{{ 'emptyEntitiesErrors.Ur' | translate }}
										</div>
									</strong>
								</div>
							</ul>
							<table class="table env1 mb-0 h-100 tableBackgrdClrBlack menuItemsClrWhite"
								*ngIf="entityExists(model.eutType)">
								<thead class="" *ngIf="entityExists(model.eutType)">
									<tr class=" row strict border-bottom1px">
										<th class="col-xs-1 ">
											<div style="text-align: center;">
												<input class="checkboxReadOnly" type="checkbox" [checked]="isAllSelected()"
													(click)="toggleAllDeselect($event.target.checked)">
											</div>
										</th>
										<th class="col-xs-1"></th>
										<th class="col-xs-9">{{ 'entities.nameOfEntity' | translate }}</th>
									</tr>
								</thead>
								<tbody class="toolEntityTBody">
									<tr class=" row strict border-bottom1px"
										*ngFor="let eut of pagedItems; let tabIndex = index">
                    <!-- pagedItems -->
										<!-- |slice : model.startAt:model.listLength -->
										<!-- |limitTo : personaMapper.model.listLength:personaMapper.model.startAt" -->
										<td class="col-xs-1 ">
											<div style="text-align: center;">
												<input class="checkboxReadOnly" type="checkbox" [checked]="isChecked(eut.eID)"
													(click)="toggleSelection(eut.eID)">
											</div>
										</td>
										<td class="col-xs-1">
											{{model.eutCollection[model.eutType].indexOf(eut)+1}}
										</td>
										<td class="col-xs-9">{{getModuleName(eut)}} | {{eut.eName}}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div class="row entity-row">
				<div style="text-align: center;">
					<div class="btn-group" role="group">
						<button id="faStepBackwardPM" class="btn btn-sm btn-default" [ngClass]="{ dis: !disableUp }" (click)="firstPage();setPage(1)">
							<fa-icon class="fa menuItemsClrBlack" [icon]="faStepBackward"></fa-icon>
						</button>
						<button id="faAngleLeftPM" class="btn btn-sm btn-default" [ngClass]="{ dis: !disableUp }" (click)="previousPage();setPage(pager.currentPage - 1)">
							<fa-icon class="fa menuItemsClrBlack" [icon]="faAngleLeft"></fa-icon>
						</button>
						<button id="faAngleRightPM" class="btn btn-sm btn-default" [ngClass]="{ dis: !disableDown }" (click)="nextPage();setPage(pager.currentPage + 1)">
							<fa-icon class="fa menuItemsClrBlack" [icon]="faAngleRight"></fa-icon>
						</button>
						<button id="faStepForwardPM" class="btn btn-sm btn-default" [ngClass]="{ dis: !disableDown }" (click)="lastPage();setPage(pager.totalPages)">
							<fa-icon class="fa menuItemsClrBlack" [icon]="faStepForward"></fa-icon>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- Section footer start -->
	<div class="headerBackground card p-1 mt-2 tool-footer-height">
		<div class='row pb-0 pt-0'>
			<div id="personamapperTip" class="carousel slide" data-ride="carousel" data-interval="false"
				data-interval="false">
				<div class="carousel-inner text-color-yellow">
					<div class="row item active text-color-yellow">
						<div class="col-xs-12 align_center carousel-tip-align">
							Tip #1 : {{'personaMapper.tip1' | translate}}
						</div>
					</div>
					<div class="row item">
						<div class="col-xs-12 align_center carousel-tip-align">
							Tip #2 : {{'personaMapper.tip2' | translate}}
						</div>
					</div>
					<div class="row item">
						<div class="col-xs-12 align_center carousel-tip-align">
							Tip #3 : {{'personaMapper.tip3' | translate}}
						</div>
					</div>
				</div>
				<a class="left carousel-control carousel-tip-align display-flex" data-target="#personamapperTip"
					data-slide="prev">
					<span>
						<fa-icon class="fas" [icon]="faChevronLeft"></fa-icon>
					</span>
					<span class="sr-only">Previous</span>
				</a>
				<a class="right carousel-control carousel-tip-align display-flex" data-target="#personamapperTip"
					data-slide="next">
					<span>
						<fa-icon class="fas" [icon]="faChevronRight"></fa-icon>
					</span>
					<span class="sr-only">Next</span>
				</a>
			</div>
		</div>
	</div>
	<!-- Section footer end -->
	<!-- Youtube video Modal -->
	<div class="modal fade bd-example-modal-lg" id="ytVideoLinkPM" tabindex="-1" role="dialog"
		aria-labelledby="ytVideoLinkPM" aria-hidden="true">
		<div class="vertical-alignment-helper">
			<div class="modal-dialog vertical-align-center">
				<div class="modal-content ytVideoLink">
					<div class="modal-header">
						<button type="button" class="close" data-dismiss="modal" (click)="terminateVideo()"
							aria-hidden="true">&times;</button>
						<h4 class="modal-title" id="myModalLabel">{{'youtubeVideoTitle.personamapper' | translate}}</h4>
					</div>
					<div class="modal-body">
						<iframe width="100%" height="100%" class="youtubeVideo" id="PmVideoLink" frameborder="0"
							allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>